/* La Bloom geo-redirect: US visitors are sent to the New York store (labloomclothingnyc.com). Bypass for previewing: add ?stay=1 to any URL (remembered for the browser session). */
(function () {
  try {
    if (new URLSearchParams(window.location.search).has('stay') || sessionStorage.getItem('lb_stay')) {
      sessionStorage.setItem('lb_stay', '1');
      return;
    }
    fetch('https://get.geojs.io/v1/ip/country.json')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (d && d.country === 'US') {
          window.location.replace('https://labloomclothingnyc.com/?ref=co');
        }
      })
      .catch(function () {});
  } catch (e) {}
})();

document.addEventListener("DOMContentLoaded", function () {
    const targetDiv = document.getElementById("site-header"); // cambia por el ID de tu div
    const claseScroll = "scroll-activo"; // la clase que se agregará

    window.addEventListener("scroll", function () {
      if (window.scrollY > 200) {
        targetDiv.classList.add(claseScroll);
      } else {
        targetDiv.classList.remove(claseScroll);
      }
    });
  });